import { useQuery } from 'react-query';

import { MEMBERSHIP_EVENT_QUERY_KEY } from '~/api/query-keys';

export type { MembershipEvent, MembershipEventResponse } from '~/api/model';

/** 플러스 멤버십 주간 이벤트 정보 */
// GET /api/market-place/v1/event/plus-membership-discount
export const usePlusMembershipEvent = () => {
  const { queryKey, queryFn } = MEMBERSHIP_EVENT_QUERY_KEY.plusMembership();

  // 주간 이벤트 정보는 변경이 잦지 않다. 프리페치 후 즉시 재요청 방지 (5분)
  return useQuery(queryKey, queryFn, { staleTime: 5 * 60 * 1000 });
};
